<template>
  <!-- 高级参照详情和新增 -->
  <mrc_ess_skeleton_loader
    :loading="$store.state.uuid ? skeletonloading : false"
  >
    <div data-app="true" class="advance">
      <mrc_ess_iconGroup
        :is_disabled="disabled"
        @handleReturn="handleReturn"
        @handleEdit="handleEdit"
        @handleDel="handleDel"
      ></mrc_ess_iconGroup>
      <v-form ref="advanceReferTo" v-model="advanceReferTo">
        <v-card>
          <v-card-text>
            <v-row v-if="$store.state.uuid">
              <v-col cols="12" sm="12">
                <div style="float: right">
                  <template v-for="item in reqParams.client_type_uuid">
                    <mrc_ess_svgIcon
                      :key="item"
                      style="font-size: 24px; margin-right: 5px"
                      :icon-class="item"
                    ></mrc_ess_svgIcon>
                  </template>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <!-- 参照名字 -->
              <v-col cols="12" sm="6">
                <mrc_ess_input
                  :placeholder="$t('label_With_reference_to_the_name')"
                  :label="$t('label_With_reference_to_the_name') + '*'"
                  required
                  style="width: 100%"
                  v-model="reqParams.prompt_name"
                  :isNational="judegNational('prompt_name')"
                  :error-messages="
                    $errors(
                      'reqParams',
                      'prompt_name',
                      requiredRule.concat(nocharacter)
                    )
                  "
                  :readonly="disabled"
                ></mrc_ess_input>
              </v-col>
              <v-col cols="12" sm="6">
                <!-- 类型 -->
                <mrc_ess_dictName
                  v-model="reqParams.prompt_type"
                  :placeholder="$t('label_type')"
                  :disabled="disabled"
                  :label="$t('label_type')"
                  :rules="false"
                  dict_name="prompt_type"
                ></mrc_ess_dictName>
              </v-col>

              <v-col cols="12">
                <!-- 描述 -->
                <mrc_ess_multiText
                  textarea
                  noRequired
                  :error-messages="
                    $errors('reqParams', 'prompt_desc', nocharacter)
                  "
                  :isNational="judegNational('prompt_desc')"
                  :placeholder="$t('label_describe')"
                  :readonly="disabled"
                  v-model="reqParams.prompt_desc"
                  :label="$t('label_describe')"
                ></mrc_ess_multiText>
              </v-col>

              <v-col cols="12">
                <!-- 客户端类型 -->
                <mrc_ess_dictName
                  v-model="reqParams.client_type_uuid"
                  :disabled="disabled"
                  :placeholder="$t('label_Client_type')"
                  :label="$t('label_Client_type') + '*'"
                  :rules="false"
                  multiple
                  :errMsg="
                    $errors('reqParams', 'client_type_uuid', requiredRule)
                  "
                  dict_name="client_type"
                >
                </mrc_ess_dictName>
              </v-col>
              <v-col cols="12" sm="6">
                <v-radio-group
                  v-model="reqParams.is_multiple"
                  :mandatory="false"
                  row
                  :disabled="disabled"
                  @change="radioChange"
                >
                  <!-- <v-radio
                    :label="$t('label_SingleTable')"
                    :value="0"
                  ></v-radio>
                  <v-radio
                    :label="$t('label_MultipleTable')"
                    :value="1"
                  ></v-radio> -->
                  <v-radio
                    v-for="(item, index) in tableRadio"
                    :key="index"
                    :label="INT(item.dict_label)"
                    :value="Number(item.dict_value)"
                  ></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12">
                <!-- 来源表名 -->
                <mrc_ess_prompt
                  :errMsg="$errors('reqParams', 'source_table', requiredRule)"
                  :label="$t('label_The_source_table_name') + '*'"
                  :disabled="disabled"
                  :multiple="Boolean(reqParams.is_multiple)"
                  :str="Boolean(reqParams.is_multiple)"
                  view_fields="table_name"
                  value_field="table_name"
                  :select_arr="source_tableArr"
                  v-model="reqParams.source_table"
                  @getData="source_tableChange"
                >
                </mrc_ess_prompt>
              </v-col>
              <v-col cols="12" v-if="reqParams.is_multiple">
                <!-- 连接方式 -->
                <!-- @changeStaffList="getModuleData" -->
                <mrc_ess_autoComplete
                  :label="$t('label_connection_method') + '*'"
                  itemText="dict_label"
                  itemValue="dict_value"
                  :readonly="disabled"
                  :error-messages="
                    $errors('reqParams', 'relate_type', requiredRule)
                  "
                  v-model="reqParams.relate_type"
                  :dropDownList="relate_typeArr"
                >
                </mrc_ess_autoComplete>
              </v-col>
              <v-col cols="12" v-if="reqParams.is_multiple">
                <!-- 关联条件 只有在没选连接方式的时候必填 -->
                <mrc_ess_input
                  :placeholder="$t('label_association_condition')"
                  :label="$t('label_association_condition') + '*'"
                  :error-messages="
                    $errors('reqParams', 'relate_filter', requiredRule)
                  "
                  :readonly="disabled"
                  v-model="reqParams.relate_filter"
                  textarea
                ></mrc_ess_input>
              </v-col>
              <v-col cols="12">
                <!-- 值 -->
                <mrc_ess_prompt
                  :select_arr="valArr"
                  :errMsg="$errors('reqParams', 'value_field', requiredRule)"
                  :disabled="disabled"
                  :label="$t('label_Take_the_column_value') + '*'"
                  :no-data-text="$t('message_source_table')"
                  value_field="field_name"
                  view_fields="table_name"
                  v-model="reqParams.value_field"
                  hideItem
                >
                  <template v-slot:selection="{ data }">
                    {{ reqParams.is_multiple ? data.item["table_name"] : "" }}
                    {{ reqParams.is_multiple ? "（" : ""
                    }}{{ data.item["field_name"] }}
                    {{ reqParams.is_multiple ? "）" : "" }}
                  </template>
                  <template v-slot:item="{ data }">
                    {{ reqParams.is_multiple ? data.item["table_name"] : "" }}
                    {{ reqParams.is_multiple ? "（" : ""
                    }}{{ data.item["field_name"] }}
                    {{ reqParams.is_multiple ? "）" : "" }}
                  </template>
                </mrc_ess_prompt>
              </v-col>
              <v-col cols="12">
                <!-- 展示列 -->
                <mrc_ess_prompt
                  :select_arr="valArr"
                  :errMsg="$errors('reqParams', 'view_fields', requiredRule)"
                  :disabled="disabled"
                  :label="$t('label_Show_columns') + '*'"
                  :no-data-text="$t('message_source_table')"
                  value_field="field_name"
                  view_fields="table_name"
                  v-model="reqParams.view_fields"
                  hideItem
                >
                  <template v-slot:selection="{ data }">
                    {{ reqParams.is_multiple ? data.item["table_name"] : "" }}
                    {{ reqParams.is_multiple ? "（" : ""
                    }}{{ data.item["field_name"] }}
                    {{ reqParams.is_multiple ? "）" : "" }}
                  </template>
                  <template v-slot:item="{ data }">
                    {{ reqParams.is_multiple ? data.item["table_name"] : "" }}
                    {{ reqParams.is_multiple ? "（" : ""
                    }}{{ data.item["field_name"] }}
                    {{ reqParams.is_multiple ? "）" : "" }}
                  </template>
                </mrc_ess_prompt>
              </v-col>

              <v-col cols="12">
                <!-- 内容 -->
                <mrc_ess_prompt
                  :select_arr="valArr"
                  value_field="field_name"
                  view_fields="table_name"
                  :errMsg="$errors('reqParams', 'prompt_field', requiredRule)"
                  :rules="$t('label_With_reference_to_the_content')"
                  :disabled="disabled"
                  :label="$t('label_With_reference_to_the_content') + '*'"
                  :no-data-text="$t('message_source_table')"
                  v-model="reqParams.prompt_field"
                  str
                  multiple
                  hideItem
                >
                  <template v-slot:selection="{ data }">
                    {{ reqParams.is_multiple ? data.item["table_name"] : "" }}
                    {{ reqParams.is_multiple ? "（" : ""
                    }}{{ data.item["field_name"] }}
                    {{ reqParams.is_multiple ? "）" : "" }}
                  </template>
                  <template v-slot:item="{ data }">
                    {{ reqParams.is_multiple ? data.item["table_name"] : "" }}
                    {{ reqParams.is_multiple ? "（" : ""
                    }}{{ data.item["field_name"] }}
                    {{ reqParams.is_multiple ? "）" : "" }}
                  </template>
                </mrc_ess_prompt>
              </v-col>

              <v-col cols="12">
                <!-- 条件 -->
                <!-- :error-messages="
                    $errors('reqParams', 'filter', nocharacter)
                  " -->
                <mrc_ess_input
                  :placeholder="$t('label_conditions')"
                  :label="$t('label_conditions')"
                  :readonly="disabled"
                  v-model="reqParams.filter"
                  textarea
                ></mrc_ess_input>
              </v-col>
              <v-col cols="12">
                <!-- 单位数据过滤 -->
                <mrc_ess_prompt
                  :select_arr="valArr"
                  :disabled="disabled"
                  :label="$t('label_Org_filter_field')"
                  :no-data-text="$t('message_source_table')"
                  value_field="field_name"
                  view_fields="table_name"
                  str
                  multiple
                  v-model="reqParams.org_filter_field"
                  hideItem
                >
                  <template v-slot:selection="{ data }">
                    {{ reqParams.is_multiple ? data.item["table_name"] : "" }}
                    {{ reqParams.is_multiple ? "（" : ""
                    }}{{ data.item["field_name"] }}
                    {{ reqParams.is_multiple ? "）" : "" }}
                  </template>
                  <template v-slot:item="{ data }">
                    {{ reqParams.is_multiple ? data.item["table_name"] : "" }}
                    {{ reqParams.is_multiple ? "（" : ""
                    }}{{ data.item["field_name"] }}
                    {{ reqParams.is_multiple ? "）" : "" }}
                  </template>
                </mrc_ess_prompt>
              </v-col>
              <v-col cols="12">
                <!-- 人员数据过滤 -->
                <mrc_ess_prompt
                  :select_arr="valArr"
                  :disabled="disabled"
                  :label="$t('label_User_filter_field')"
                  :no-data-text="$t('message_source_table')"
                  value_field="field_name"
                  view_fields="table_name"
                  str
                  multiple
                  v-model="reqParams.user_filter_field"
                  hideItem
                >
                  <template v-slot:selection="{ data }">
                    {{ reqParams.is_multiple ? data.item["table_name"] : "" }}
                    {{ reqParams.is_multiple ? "（" : ""
                    }}{{ data.item["field_name"] }}
                    {{ reqParams.is_multiple ? "）" : "" }}
                  </template>
                  <template v-slot:item="{ data }">
                    {{ reqParams.is_multiple ? data.item["table_name"] : "" }}
                    {{ reqParams.is_multiple ? "（" : ""
                    }}{{ data.item["field_name"] }}
                    {{ reqParams.is_multiple ? "）" : "" }}
                  </template>
                </mrc_ess_prompt>
              </v-col>
              <v-col cols="12">
                <!-- 排序 -->
                <mrc_ess_input
                  :disabled="disabled"
                  :label="$t('label_The_sorting')"
                  v-model="reqParams.orderby"
                ></mrc_ess_input>
                <!-- <mrc_ess_prompt :select_arr="valArr"
                                :rules="false"
                                value_field="field_name"
                                view_fields="table_name"
                                :disabled="disabled"
                                :label="$t('label_The_sorting')"
                                :no-data-text="$t('message_source_table')"
                                v-model="reqParams.orderby"
                                hideItem>
                  <template v-slot:selection="{ data }">
                    {{ reqParams.is_multiple ? data.item['table_name'] : '' }}
                    {{ reqParams.is_multiple ? '（' : ''
                    }}{{ data.item['field_name'] }}
                    {{ reqParams.is_multiple ? '）' : '' }}
                  </template>
                  <template v-slot:item="{ data }">
                    {{ reqParams.is_multiple ? data.item['table_name'] : '' }}
                    {{ reqParams.is_multiple ? '（' : ''
                    }}{{ data.item['field_name'] }}
                    {{ reqParams.is_multiple ? '）' : '' }}
                  </template>
                </mrc_ess_prompt> -->
              </v-col>
            </v-row>
          </v-card-text>
          <mrc_ess_submitBtn
            v-show="!disabled"
            @cancel="cancel"
            :loading="loading"
            @success="success"
          ></mrc_ess_submitBtn>
        </v-card>
      </v-form>
    </div>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  getBusinessList,
  getDetail,
  getChange,
  getAdd,
  getDetele,
  mutipleTable,
  accordingTableGetValue,
} from "@/service/api/prompt";
import { getDataByName } from "@/service/api/data_dictionary";
import confirm from "@/components/confirm";
// import myBtns from '@/components/c_s_btns'
// import iconGroup from '@/components/iconGroup'
import { required, maxLength } from "vuelidate/lib/validators";

export default {
  components: { confirm },
  props: {},
  validations: {
    reqParams: {
      prompt_name: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      prompt_desc: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      client_type_uuid: {
        required,
      },
      source_table: {
        required,
      },
      value_field: {
        required,
      },
      view_fields: {
        required,
      },
      prompt_field: {
        required,
      },
      filter: {
        // maxLength: maxLength(6000),
        // nocharacter (value) {
        //   return this.$myVerify.nocharacter(this.INT(value))
        // },
      },
      relate_type: {
        required() {
          if (this.reqParams.is_multiple && !this.reqParams.relate_type) {
            return false;
          }
          return true;
        },
      },
      relate_filter: {
        required() {
          if (this.reqParams.is_multiple && !this.reqParams.relate_filter) {
            return false;
          }
          return true;
        },
        // nocharacter (value) {
        //   return this.$myVerify.nocharacter(this.INT(value))
        // },
      },
    },
  },
  data() {
    return {
      loading: false,
      skeletonloading: true,
      isLoading: false,
      isOpen: false,
      params: {
        "~table~": "mrbase_sys_prompt",
      },
      reqParams: {
        // 这是会被修改的 修改失败就把之前的还原  temp->reqParams
        "~table~": "mrbase_sys_prompt",
        prompt_name: "", // 参照名称
        prompt_desc: "", // 参照描述
        source_table: "", // 数据来源表
        value_field: "", // 取值列
        view_fields: "", // 显示列
        // user_filter_field: '',// 人员数据过滤字段，多个逗号分隔使用数据权限
        // org_filter_field: '',// 单位数据过滤字段，多个逗号分隔使用数据权限
        prompt_type: "", // 分类
        orderby: "", // 排序
        prompt_field: "", // 参照内容
        client_type_uuid: [], // 客户端类型
        uuid: "",
        filter: "",
        dict_value: "",
        is_multiple: 0,
        relate_type: "",
        relate_filter: "",
        org_filter_field: "",
        user_filter_field: "",
      },
      relate_typeArr: [], // 连接方式 下拉列表
      source_tableArr: [], // 来源表下拉
      temp: {}, // 存查询出来的数据
      source_table_name: [], // 来源表名列表
      valArr: [], // 取值列 列表
      disabled: false,
      advanceReferTo: true,
      promptData: {},
      tableRadio: [],
    };
  },
  created() {
    this.promptData = { prompt_name: "table_name" };
  },
  async mounted() {
    await this.national("mrbase_sys_prompt");
    this.$nextTick(async () => {
      // 有uuid传过来 就是修改 没有就是新增，
      // const name = this.$store.getters.subPage_name
      const uuid = this.$route.params.uuid || this.$store.state.uuid;
      // 查询连接方式下拉
      this.getSearchType();
      await this.getTableRadio();
      this.skeletonloading = true;
      if (uuid) {
        this.reqParams.prompt_name = name;
        this.reqParams.uuid = uuid;
        // 查询详情
        let detailObj = await this.getdetail();
        for (var key in detailObj) {
          for (var a in this.reqParams) {
            if (key == a) {
              this.reqParams[a] = detailObj[key];
            }
          }
        }
        // if (this.reqParams.prompt_field) {
        //   this.reqParams.prompt_field = this.reqParams.prompt_field.split(',')
        // }

        if (detailObj.client_type_uuid) {
          this.reqParams.client_type_uuid =
            this.reqParams.client_type_uuid.split(",");
        }

        // 根据关联表获取列值
        await this.accordingToTableList();

        if (this.$store.state.iconstatus) {
          this.disabled = true;
        }
      } else {
        this.disabled = false;
      }
      // 查询来源表名下拉
      this.getSourchTableList();
      this.skeletonloading = false;
      // const searchArr = await this.search()
      // this.source_table_name = searchArr
    });
  },
  methods: {
    // 根据普通参照请求 单表多表的选项
    async getTableRadio() {
      try {
        const res = await getDataByName("SingleTableOrMultipleTable");
        if (res.code == 200) {
          this.tableRadio = res.data;
        }
      } catch (err) {
        const res = await getDataByName("SingleTableOrMultipleTable");
        if (res.code == 200) {
          this.tableRadio = res.data;
        }
      }
    },
    // 根据已选择的来源表查询 的 下拉
    async accordingToTableList() {
      try {
        const valArr = await accordingTableGetValue({
          table_name: this.reqParams.source_table,
          is_multiple: this.reqParams.is_multiple,
        });
        this.valArr = valArr.data;
      } catch (err) {
        const valArr = await accordingTableGetValue({
          table_name: this.reqParams.source_table,
          is_multiple: this.reqParams.is_multiple,
        });
        this.valArr = valArr.data;
      }
    },
    // 查询来源表下拉
    async getSourchTableList() {
      try {
        const res = await mutipleTable({
          is_multiple: this.reqParams.is_multiple,
        });
        if (res.code == 200) {
          this.source_tableArr = res.data;
        }
      } catch (err) {
        const res = await mutipleTable({
          is_multiple: this.reqParams.is_multiple,
        });
        if (res.code == 200) {
          this.source_tableArr = res.data;
        }
      }
    },
    // 查询连接方式下拉
    async getSearchType() {
      try {
        const relate_type = await getDataByName("relate_type");
        if (relate_type.code == 200) {
          this.relate_typeArr = relate_type.data;
        }
      } catch (err) {
        const relate_type = await getDataByName("relate_type");
        if (relate_type.code == 200) {
          this.relate_typeArr = relate_type.data;
        }
      }
    },
    // 取消修改新增
    async cancel() {
      if (this.$store.state.uuid) {
        let detailObj = await this.getdetail();
        for (var key in detailObj) {
          for (var a in this.reqParams) {
            if (key == a) {
              this.reqParams[a] = detailObj[key];
            }
          }
        }

        if (detailObj.client_type_uuid) {
          this.reqParams.client_type_uuid =
            this.reqParams.client_type_uuid.split(",");
        }
        // 根据关联表获取列值
        await this.accordingToTableList();

        this.disabled = !this.disabled;
      } else {
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then(() => {
            this.$router.go(-1);
          })
          .catch(() => {});
      }
    },
    // 提交修改新增
    async success() {
      const name = this.$store.state.uuid;
      // 判断 必填是否完成
      this.$v.reqParams.$touch();
      if (this.$v.reqParams.$error) {
        return;
      }
      this.isLoading = true;
      this.loading = true;
      const obj = this.$clone(this.reqParams);
      // obj.prompt_field = obj.prompt_field.join()
      obj.client_type_uuid = obj.client_type_uuid.join();
      if (name) {
        const res = await getChange(obj)
          .then((res) => {
            this.isLoading = false;
            if (res.code == 200) {
              this.$Message({
                text: this.$t("message_The_operation_was_successful"),
              });
              // this.$router.go(-1)
              this.disabled = !this.disabled;
            }
            this.loading = false;
            return res;
          })
          .catch((err) => {
            this.loading = false;
            return err;
          });
      } else {
        const res = await getAdd(obj)
          .then((res) => {
            this.isLoading = false;
            if (res.code == 200) {
              this.$Message({
                text: this.$t("message_The_operation_was_successful"),
              });
              this.$router.go(-1);
            }
            this.loading = false;
            return res;
          })
          .catch((err) => {
            this.loading = false;
            return err;
          });
      }
    },
    // 点击删除此参照
    handleDel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      })
        .then(() => {
          // 确认删除
          const obj = Object.assign({}, this.params, {
            uuid: this.reqParams.uuid,
          });
          getDetele(obj)
            .then((res) => {
              this.$Message({
                text: this.$t("message_The_deletion_was_successful"),
              });
              if (res.code == 200) {
                // if (
                //   this.$parent.desserts.length === 1 &&
                //   this.$parent.params.cpage > 1
                // ) {
                //   this.$parent.params.cpage--
                //   this.$parent.params.totalpage--
                // }
                this.$router.go(-1);
              } else {
                this.$Message({
                  text: res.msg,
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          // console.log("点了取消")
        });
    },

    // 点击修改icon
    handleEdit() {
      this.disabled = !this.disabled;
    },
    // 点击返回上一页
    handleReturn() {
      this.$router.go(-1);
    },
    // 查询高级参照 默认查询来源表名
    async search(params = {}) {
      const obj = Object.assign(
        {},
        this.params,
        { prompt_name: "table_name" },
        params
      );
      const arr = await getBusinessList(obj);

      return arr.data;
    },
    // 获取详情
    async getdetail() {
      const obj = Object.assign({}, this.params, { uuid: this.reqParams.uuid });

      const arr = await getDetail(obj)
        .then((res) => {
          if (res.code == 200) {
            return res.data;
          } else {
            this.$Message({ text: res.msg });
          }
        })
        .catch((err) => {
          console.log(err);
        });
      return arr;
    },
    // 关联表值切换就去找下面关联的
    async source_tableChange(val) {
      // this.reqParams.source_table = val
      this.valArr = [];
      if (val) {
        await this.accordingToTableList();
      }

      // 来源表名切换  下面的几项重置
      this.reqParams.value_field = "";
      this.reqParams.view_fields = "";
      this.reqParams.orderby = "";
      this.reqParams.prompt_field = "";

      if (this.reqParams.is_multiple) {
        this.relate_type = "";
        this.relate_filter = "";
      }
    },
    async radioChange(val) {
      await this.getSourchTableList();
      this.relate_type = "";
      this.relate_filter = "";
      if (val) {
        this.reqParams.source_table = "";
        this.source_tableChange();
      }
    },
  },
  computed: {},
  watch: {
    disabled: {
      handler(v) {
        if (!this.$store.state.uuid) return;
        if (!v) {
          this.$route.meta.title = "label_edit_advanced_referencesv";
          this.$store.commit(
            "set_page_title",
            "label_edit_advanced_referencesv"
          );
        } else {
          this.$route.meta.title = "label_view_advanced_referencesv";
          this.$store.commit(
            "set_page_title",
            "label_view_advanced_referencesv"
          );
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.iconGroup {
  position: relative;
}
.returnBtn {
  color: #fff;
  position: absolute;
  top: -55px;
  right: 130px;
}
.editBtn {
  color: #fff;
  position: absolute;
  top: -55px;
  right: 70px;
}
.delBtn {
  color: #fff;
  position: absolute;
  top: -55px;
  right: 10px;
}
/* .btnGroup {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 200px;
  margin: 0 auto;
  margin-top: 20px;
}
.successBtn {
  color: #fff;
}
.cencelBtn {
  color: #ffad4d;
} */
.advance /deep/ .v-menu__content {
  min-width: 400px !important;
}
</style>
